import {createContext} from 'react';

import {TAuditImageSelectionContext} from '../types/TAuditImageSelectionContext';

/**
 * Provides bulk-selection state to audit image components (AuditImage / UploadImage)
 * rendered across the per-card UploadContext boundaries. The default value keeps
 * selection disabled so galleries that are not wrapped in a provider (e.g. damage
 * photos) keep behaving exactly as before.
 */
export const AuditImageSelectionContext = createContext<TAuditImageSelectionContext>({
  isBulkActionsEnabled: false,
  isSelectionMode: false,
  isImageSelected: () => false,
  toggleImageSelection: () => {},
  registerSelectableImage: () => {},
  unregisterSelectableImage: () => {},
});
